var SCM = SCM || {};

(function (ns, $) {
    
    ns.institutionalAccountClick = function () {
        var accountId = $(this).attr('data-account-id');
        if ($('.js-institution-dropdown-wrap').length) {
            $('.js-institution-dropdown-wrap').removeClass('hide');
            accountId = $('.js-institution-dropdown-wrap').find(':selected').val();
        }
        setSelectedAccountId(accountId);
    };
    
    ns.individualAccountClick = function () {
        $('.js-institution-dropdown-wrap').removeClass('hide').addClass('hide');
        setSelectedAccountId($(this).attr('data-account-id'));
    };
    
    ns.institutionDropdownChange = function () {
        setSelectedAccountId($(this).val());
    };
    
    function setSelectedAccountId(accountId) {
        $('#hdnSelectedInstitutionId').val(accountId);
    }

    ns.initActivateSubscription = function (lastError) {

        var $formContainer = $('.activate-subscription-wrap');

        if (lastError != null && lastError.length > 0) {
            $formContainer.find('.error-message').html(lastError).show();
            SCM.MyAccount.cleanLastErrorMessage();
        }
        var simpleCaptchaEnabled = $('div.register-captcha-text-simple-sub').length > 0;
        var normalCaptchaEnabled = $('div.register-captcha-text-normal-sub').length > 0;

        var simpleCaptchaIdName = 'txtCaptchaInputId';

        if (normalCaptchaEnabled) {
            resetCaptchaElement();
        }
        else if (simpleCaptchaEnabled) {
            simpleCaptchaIdName += '-0';
        }

        $('#activateSubscriptionBtn').on('click', function () {
            $('#activateSubscriptionBtn').addClass('disabled');
            var $formContainer = $('.activate-subscription-wrap');

            var $errMsg = $formContainer.find('.error-message');
            $errMsg.html('').hide();
            $formContainer.find('#successMessage').hide();

            if ($('#activateSubscriptionTermsConditions').is(':checked') === false) {
                $errMsg.html($('#activateSubErrTermsConditions').html()).show();
                $('#activateSubscriptionBtn').removeClass('disabled');
                $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
            }
            else {
                var token = $('#activateSubscriptionToken').val();
                var accountId = $('#hdnSelectedInstitutionId').val();
                var accountType = $('input[name="account-type"]:checked').val();

                if (token.length > 0) {
                    $.post('/OUPMyAccount/ActivateSubscriptionSubmitToken',
                        {
                            token: token,
                            accountId: accountId,
                            accountType: accountType,
                            captchaResponse: normalCaptchaEnabled ? grecaptcha.getResponse(0) : '',
                            simpleCaptchaResponse: simpleCaptchaEnabled
                                ? document.getElementById(simpleCaptchaIdName).value
                                : '',
                            captchaInstanceNumber: 0
                        },
                        function (result) {
                            if (result === 'subscriptions') {
                                location.href = '/my-account/subscriptions';
                            } else if (result === 'institutional-settings') {
                                // delay to make sure that the SGK is refreshed
                                setTimeout(function () { location.href = '/my-account/institutional-settings'; }, 1000);
                            } else {
                                window.location.reload();
                            }
                        }, 'html')
                        .fail(function () {
                            $('#activateSubscriptionBtn').removeClass('disabled');
                            $errMsg.html(
                                'The code or subscriber number is not found. Please check and try again. ' +
                                'If the problem continues, please contact <a href="/pages/contact_us">customer services</a>.')
                                .show();
                        });
                } else {
                    $('#activateSubscriptionBtn').removeClass('disabled');
                }
            }
        });

        $('#activateSubscriptionToken').on('keypress', function (e) {
            var code = e.keyCode || e.which;
            if (code === 13) {
                e.preventDefault();
                $('#activateSubscriptionBtn').click();
            }
        });
    };

    $(document).on('click', '.js-product-code-all', function (event) {
        var $parentList = $(this).closest('.js-product-code-list');
        $parentList.find('.js-product-code-all').hide();
        var $notVisible = $parentList.children('.js-product-code:hidden');

        $notVisible.animate({ height: 'toggle' }, 200).promise().done(function () {
            $parentList.find('.js-product-code-less').show();
        });

        event.preventDefault();
    });

    $(document).on('click', '.js-product-code-less', function (event) {
        var $parentList = $(this).closest('.js-product-code-list');
        $parentList.find('.js-product-code-less').hide();
        var limit = $('#hdnProductCodeListLimit').val();
        var $visibleToHide = $parentList.children('.js-product-code:gt(' + (limit - 1) + ')');

        $visibleToHide.animate({ height: 'toggle' }, 200).promise().done(function () {
            $parentList.find('.js-product-code-all').show();
        });

        event.preventDefault();
    });

})(SCM.MyAccount = SCM.MyAccount || {}, jQuery);

$(function () {
    if (!$('.js-account-type-individual').is(':checked')) {
        $('.js-account-type-individual').attr('checked', 'checked');
    }
    
    $('.js-account-type-institutional').on('click', SCM.MyAccount.institutionalAccountClick);
    $('.js-account-type-individual').attr('checked', 'checked').on('click', SCM.MyAccount.individualAccountClick);
    $('.js-institution-dropdown').on('change', SCM.MyAccount.institutionDropdownChange);
    
});